import React, { useMemo } from "react";
import { useStore } from "../../../stores/store";
import Extent from "@arcgis/core/geometry/Extent";
import townshipExtents from "../../../utils/townshipExtents";

export const CityZoomTab = () => {
  const { zoomToExtent, mapView } = useStore();

  const options = useMemo(() => townshipExtents, []);
  return (
    <ul className="max-h-[80vh] md:max-h-[40vh] overflow-auto my-3 bg-gray-700 text-white">
      {options.map((option, i) => (
        <li key={i} className="cursor-pointer">
          <button
            disabled={false}
            onClick={() => {
              const extent = new Extent({
                ...option.extent,
                spatialReference: mapView?.spatialReference,
              });
              zoomToExtent(extent);
            }}
            className="w-full pl-3 py-1 hover:bg-[#393838] hover:text-white hover:underline text-left"
          >
            {option.name}
          </button>
        </li>
      ))}
    </ul>
  );
};
